/* eslint-disable import/no-anonymous-default-export */
import Keycloak from 'keycloak-js'

import { 
    loginSuccess, 
    updateTokenSuccess, 
    logoutSuccess,
} from '../actions/kc_ops_actions';

class KeyCloakOps {
    constructor() {
        this.kc = new Keycloak({
            url: `${process.env.REACT_APP_KC_HOST}`,
            realm: `${process.env.REACT_APP_KC_CLIENT_REALM}`,
            clientId: `${process.env.REACT_APP_KC_CLIENT_ID}`,
        })
    }

    async initKeycloak(store) {
        try {
            const authenticated = await this.kc.init({
                onLoad: 'login-required',
                checkLoginIframe: false,
                pkceMethod: 'S256',
                redirectUri: window.location.origin,
                silentCheckSsoRedirectUri: window.location.origin,
                flow: 'standard',
                enableLogging: true,
                scope: `${process.env.REACT_APP_KC_CLIENT_SCOPE}`
            });
            if (authenticated) {
                const profile = await this.kc.loadUserProfile();
                store.dispatch(loginSuccess(this.kc, profile, this.kc.token));
                //
                this.kc.onTokenExpired = () => this.handleTokenRefresh(store);
            }
            return(this.kc)
        } catch (error) {
            console.error('Keycloak init failed', error);
            throw error;
        }
    }

    async handleTokenRefresh(store) {
        try {
            const refreshed = await this.kc.updateToken(90);
            if(refreshed && store) {
                store.dispatch(updateTokenSuccess(this.kc, this.kc.token));
            }
            return this.kc.token;
        } catch (error) {
            console.error('Failed to refresh token', error);
            if (store) store.dispatch(logoutSuccess());
            this.login();
        }
    }

    registerInterceptor(axiosInstance, store) {
        axiosInstance.interceptors.request.use(async (config) => {
            if(this.kc.authenticated) {
                const token = await this.handleTokenRefresh(store);
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
            (error) => Promise.reject(error)
        );
    }

    login() { this.kc.login(); }
    logout() { this.kc.logout(); }
    getToken() { return this.kc.token; }           
}

export default new KeyCloakOps();